var parkingLocationPages = {
  'aberdeen-airport-parking': 'Aberdeen Airport Parking',
  'belfast-airport-parking': 'Belfast airport parking',
  'belfast-city-airport-parking': 'Belfast City airport parking',
  'birmingham-airport-parking': 'Birmingham airport parking',
  'bristol-airport-parking': 'Bristol airport parking',
  'bournemouth-airport-parking': 'Bournemouth airport parking',
  'cardiff-airport-parking': 'Cardiff airport parking',
  'doncaster-airport-parking': 'Doncaster airport parking',
  'dublin-airport-parking': 'Dublin airport parking',
  'eastmidlands-airport-parking': 'East Midlands airport parking',
  'edinburgh-airport-parking': 'Edinburgh airport parking',
  'exeter-airport-parking': 'Exeter airport parking',
  'gatwick-airport-parking': 'Gatwick parking',
  'glasgow-airport-parking': 'Glasgow airport parking',
  'heathrow-airport-parking': 'Heathrow parking',
  'humberside-airport-parking': 'Humberside airport parking',
  'inverness-airport-parking': 'Inverness airport parking',
  'leeds-bradford-airport-parking': 'Leeds Bradford airport parking',
  'liverpool-airport-parking': 'Liverpool airport parking',
  'london-city-airport-parking': 'London-City airport parking',
  'luton-airport-parking': 'Luton airport parking',
  'manchester-airport-parking': 'Manchester airport parking',
  'newcastle-airport-parking': 'Newcastle airport parking',
  'norwich-airport-parking': 'Norwich airport parking',
  'prestwick-airport-parking': 'Prestwick airport parking',
  'shannon-airport-parking': 'Shannon airport parking',
  'southampton-airport-parking': 'Southampton airport parking',
  'southend-airport-parking': 'Southend airport parking',
  'stansted-airport-parking': 'Stansted airport parking',
  'teesside-airport-parking': 'Teesside airport parking'
}

module.exports = parkingLocationPages



// WEBPACK FOOTER //
// ./shared/config/parkingLocationPages.js